import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../index';

export const getProductionAnalysisSetComponentDesignByAnalysisSetGuid = createSelector(
  (state: RootState) => state.productionModels.analysisSetGuidToComponentDesignGuid,
  (state: RootState) => state.componentDesigns.data,

  (analysisSetGuidToComponentDesignGuid, componentDesignsByGuid) =>
    mapValues(
      analysisSetGuidToComponentDesignGuid,
      (componentDesignGuid) => componentDesignsByGuid[componentDesignGuid],
    ),
);
